import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect } from "react";
import Layout from "../components/Layout";
import objectFitImages from "object-fit-images";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../scss/style.default.scss";
import useRouterScroll from "../lib/useRouterScroll";
import Store from "../lib/Store";
import { jsx as _jsx } from "react/jsx-runtime";

var App = function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  useRouterScroll();
  useEffect(function () {
    objectFitImages();
  }, []);
  return /*#__PURE__*/_jsx(Store, {
    children: /*#__PURE__*/_jsx(Layout, _objectSpread(_objectSpread({}, pageProps), {}, {
      children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
    }))
  });
}; // This default export is required in a new `pages/_app.js` file.


export default App;